/**
 * Hook: useActivitySuspension
 *
 * Récupère et expose le statut de suspension volontaire de l'activité
 * de l'utilisateur connecté. Utilisé par le banner global et les pages.
 */

import { useState, useEffect, useCallback, useRef } from 'react';
import { useAuth } from '../context/AuthContext';
import activitySuspensionService from '../services/activitySuspensionService';

export function useActivitySuspension() {
  const { isAuthenticated } = useAuth();

  const [loading, setLoading] = useState(true);
  const [isSuspended, setIsSuspended] = useState(false);
  const [suspendedAt, setSuspendedAt] = useState(null);
  const [suspensionReason, setSuspensionReason] = useState(null);
  const [listingsDeactivated, setListingsDeactivated] = useState(0);
  const [productsDeactivated, setProductsDeactivated] = useState(0);

  const fetchedRef = useRef(false);

  const fetchStatus = useCallback(async () => {
    if (!isAuthenticated) {
      setLoading(false);
      return;
    }
    try {
      const data = await activitySuspensionService.getStatus();
      setIsSuspended(!!data?.isSuspended);
      setSuspendedAt(data?.suspendedAt || null);
      setSuspensionReason(data?.suspensionReason || null);
      setListingsDeactivated(data?.listingsDeactivated || 0);
      setProductsDeactivated(data?.productsDeactivated || 0);
    } catch {
      // Ne pas faire crasher l'app si l'endpoint est indisponible
      setIsSuspended(false);
    } finally {
      setLoading(false);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (!fetchedRef.current) {
      fetchedRef.current = true;
      fetchStatus();
    }
  }, [fetchStatus]);

  return {
    loading,
    isSuspended,
    suspendedAt,
    suspensionReason,
    listingsDeactivated,
    productsDeactivated,
    refresh: fetchStatus
  };
}
